"use client";

import { useState } from "react";
import Link from "next/link";

import { useAuth } from "@/context/auth-context";
import { GuestInviteModal } from "@/components/guest-invite-modal";
import { cn } from "@/lib/utils";

interface InviteFriendsCtaProps {
  className?: string;
  children: React.ReactNode;
  guestOnly?: boolean;
}

export function InviteFriendsCta({ className, children, guestOnly = false }: InviteFriendsCtaProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const [open, setOpen] = useState(false);

  if (guestOnly && (isLoading || isAuthenticated)) {
    return null;
  }

  if (!isLoading && isAuthenticated) {
    return (
      <Link href="/invite-friends" className={className}>
        {children}
      </Link>
    );
  }

  return (
    <>
      <button type="button" className={cn("cursor-pointer", className)} onClick={() => setOpen(true)}>
        {children}
      </button>
      <GuestInviteModal open={open} onOpenChange={setOpen} />
    </>
  );
}
